import { Notifications as NotificationsIcon } from "../../../_app/components/icons";
import SimpleNavWidget from "./SimpleNavWidget";

const UsageAlertsLink = ({ ...props }) => {
  return (
    <SimpleNavWidget
      title="Usage Alerts"
      description="Limit the potential of overusage and access charges."
      link="/usage-alerts"
      icon={<NotificationsIcon />}
      {...props}
    />
  );
};

export default UsageAlertsLink;
